import { fetchToken } from "../../../common/FetchCookie";
import { PAYMENT_GATEWAY } from "../../../common/URLs";


export const PaymentGateway = async (uuid) => {
  const url = `${PAYMENT_GATEWAY}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        // Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(uuid),
    });
    const data = await response.json(); 
    // console.log("API Data", data);
    return data;
  } catch (error) {
    // console.log("error", error);
    // throw error;
    return error;
  }
};
